/**
 * API de consentimento de cookies — Web App /ia (React).
 *
 * Idêntica à versão do site Astro para consistência de comportamento.
 * O banner do site e o banner do /ia compartilham a mesma chave localStorage,
 * portanto se o usuário já aceitou no site, o /ia respeita a decisão.
 *
 * LGPD/GDPR: 'denied' = zero cookies de rastreio, GA4 não carrega.
 */

export const CONSENT_KEY = 'drpera-cookie-consent';
export type ConsentStatus = 'granted' | 'denied' | null;

/**
 * Retorna o status atual de consentimento.
 * Retorna null se o usuário ainda não decidiu.
 */
export function getConsent(): ConsentStatus {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return null;
  }
  const valor = localStorage.getItem(CONSENT_KEY);
  if (valor === 'granted' || valor === 'denied') return valor;
  return null;
}

/**
 * Salva decisão e dispara CustomEvent para carregamento dinâmico do GA4.
 */
export function setConsent(status: 'granted' | 'denied'): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(CONSENT_KEY, status);
  window.dispatchEvent(
    new CustomEvent('drpera-consent-change', { detail: status })
  );
}

/**
 * Remove o consentimento (direito de retirada — LGPD art. 8º §5).
 */
export function clearConsent(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(CONSENT_KEY);
}
